import { AssetModel } from '../models';

const parseEquipment = (equipment, figure, converted = false) => {
  if (!figure || !equipment) return {};
  const items = converted ? equipment : equipment.map(e => AssetModel.fromBasejumpEquipment(e));
  const weapons = items.filter(w => w.getType() === 'weapon').map((w) => ({ weaponType: w.nftData.subtype, weaponGlbPath: w.nftData.glb, effects: w.getEffects() }));
  const equippedObject = items.find(w => w.getType() === 'object');
  const objectPath = (equippedObject && ['shield', 'equip', 'food'].includes(equippedObject.nftData.subtype)) ? equippedObject.nftData.glb : null;
  const objectType = objectPath ? equippedObject.nftData.subtype : null;
  const dronePath = (equippedObject && (equippedObject.nftData.subtype || '').startsWith('drone')) ? equippedObject.nftData.glb : null;
  const droneType = (dronePath && equippedObject.nftData.subtype === 'drone_dance')
    ? 'dance'
    : (dronePath && equippedObject.nftData.subtype === 'drone_mutatio')
      ? 'mutatio'
      : null;
  const companionPath = (equippedObject && (equippedObject.nftData.subtype === 'companion')) ? equippedObject.nftData.glb : null;

  const armorObject = items.find(w => w.getType() === 'armor');
  let armorPath = null;
  if (armorObject) {
    armorPath = armorObject.nftData.glb;
    if (figure.isHenchie() && armorObject.nftData.henchie_glb) {
      armorPath = armorObject.nftData.henchie_glb;
    }
  }
  return {
    droneType,
    dronePath,
    objectType,
    objectPath,
    companionPath,
    weapons,
    armorPath
  }
};

export default parseEquipment;
